import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BaseComponent } from '~app/app/~shared/abstract-components/base.component';
import { BrandCreationFormComponent } from '../../components/brand-creation-form/brand-creation-form.component';
import { Brand } from '~core/models/brand.models';

@Component({
  selector: 'brand-creation-dialog',
  standalone: true,
  imports: [BrandCreationFormComponent],
  templateUrl: './brand-creation-dialog.component.html',
  styleUrl: './brand-creation-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BrandCreationDialogComponent extends BaseComponent {
  brand = input<Brand | null>(null);
}
